import React from "react";
import { Panel } from "components/containers";

const ContentPanel = ({ title, children, className }) => {
  return (
    <Panel border="none" className={className}>
      <h3>{title}</h3>
      {children}
    </Panel>
  );
};

export default ContentPanel;
